import { useNavigate } from "react-router-dom";

export default function AdmissionProcess() {

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate("/terms-conditions");
    };

    return (
        <>
            <section id="admission-process-section">
                <div className="admission-process-container">
                    <div className="admission-process-header">
                        <h2 className="section-title">PROCESS OF COMPLETING YOUR ADMISSION</h2>
                    </div>

                    <div className="admission-process-cards">
                        <div className="admission-process-card">
                            <div className="process-number">1</div>
                            <div className="process-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14,2 14,8 20,8" />
                                    <line x1="16" y1="13" x2="8" y2="13" />
                                    <line x1="16" y1="17" x2="8" y2="17" />
                                    <polyline points="10,9 9,9 8,9" />
                                </svg>
                            </div>
                            <h3 className="process-title">READ TERMS & CONDITIONS</h3>
                            <p className="process-description">Read the Terms and condition, Class Policy carefully in section 2 of the form.</p>
                        </div>

                        <div className="admission-process-card">
                            <div className="process-number">2</div>
                            <div className="process-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="2" y="6" width="20" height="12" rx="2" />
                                    <circle cx="12" cy="12" r="2" />
                                    <path d="M6 12h.01M18 12h.01" />
                                </svg>
                            </div>
                            <h3 className="process-title">COMPLETE PAYMENT</h3>
                            <p className="process-description">Complete the tuition fee payment first & take a screenshot of it to attach in the form.</p>
                        </div>

                        <div className="admission-process-card">
                            <div className="process-number">3</div>
                            <div className="process-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14,2 14,8 20,8" />
                                    <path d="M16 13H8" />
                                    <path d="M16 17H8" />
                                    <path d="M10 9H9H8" />
                                </svg>
                            </div>
                            <h3 className="process-title">FILL APPLICATION FORM</h3>
                            <p className="process-description">Fill the application form and attach the payment screenshot in the application form.</p>
                        </div>

                        <div className="admission-process-card">
                            <div className="process-number">4</div>
                            <div className="process-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14,2 14,8 20,8" />
                                    <line x1="16" y1="13" x2="8" y2="13" />
                                    <line x1="16" y1="17" x2="8" y2="17" />
                                    <polyline points="10,9 9,9 8,9" />
                                </svg>
                            </div>
                            <h3 className="process-title">COLLECT INVOICE</h3>
                            <p className="process-description">After completing admission process, collect your invoice from academy.</p>
                        </div>

                        <div className="admission-process-card">
                            <div className="process-number">5</div>
                            <div className="process-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                                    <path d="M6 12v5c3 3 9 3 12 0v-5" />
                                </svg>
                            </div>
                            <h3 className="process-title">START LEARNING</h3>
                            <p className="process-description">Start your musical learning journey with us!</p>
                        </div>
                    </div>

                    <div className="admission-process-cta">
                        <button className="rules-btn" onClick={handleRedirect}>RULES & REGULATIONS</button>
                    </div>
                </div>
            </section>
        </>
    );
} 